<div class="settings-page categories-page">
  <div class="settings-topbar">
    <div class="topbar-left">
      <h1>
        Categories
        <small>Inventory product categories</small>
      </h1>
      <div class="breadcrumb">
        <i class="bi bi-house-door"></i>
        IMS / Settings / <span class="current">Categories</span>
      </div>
    </div>
    <div class="topbar-right">
      <button type="button" class="btn btn-primary" (click)="openModal()">
        <i class="bi bi-plus-circle"></i> Add Category
      </button>
    </div>
  </div>

  <div class="settings-table-wrap">
    <div class="table-scroll">
      <table class="report-data-table">
        <thead>
          <tr>
            <th>Code</th>
            <th>Name</th>
            <th>Description</th>
            <th>Status</th>
            <th class="text-center">Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (row of categories(); track row.id) {
            <tr>
              <td><span class="fw-semibold">{{ row.code }}</span></td>
              <td>{{ row.name }}</td>
              <td>
                <span class="category-description" [class.text-muted]="!row.description">
                  {{ row.description || '—' }}
                </span>
              </td>
              <td>
                <span class="status-pill" [class.active]="row.status === 'active'">
                  {{ row.status }}
                </span>
              </td>
              <td class="actions-cell">
                <div class="row-actions">
                  <button type="button" class="btn-action edit" title="Edit category" (click)="openEdit(row)">
                    <i class="bi bi-pencil"></i>
                  </button>
                  <button type="button" class="btn-action delete" title="Delete category" (click)="deleteRow(row)">
                    <i class="bi bi-trash"></i>
                  </button>
                </div>
              </td>
            </tr>
          } @empty {
            <tr>
              <td colspan="5" class="text-center py-4 text-muted">
                <i class="bi bi-inbox empty-state-icon"></i>
                No categories found. Click "Add Category" to create one.
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
</div>

@if (showModal()) {
  <div class="modal-overlay open" (click)="closeModal()">
    <div class="settings-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h2 class="modal-title">
          <i class="bi" [class]="isEditing() ? 'bi-pencil' : 'bi-plus-circle'"></i>
          {{ isEditing() ? 'Edit Category' : 'Add Category' }}
        </h2>
        <button type="button" class="close-btn" (click)="closeModal()">
          <i class="bi bi-x-lg"></i>
        </button>
      </div>
      <div class="modal-body">
        <div class="form-group">
          <label class="form-label">Code <span class="text-danger">*</span></label>
          <input type="text" class="form-control" [(ngModel)]="categoryForm.code" placeholder="Enter category code" />
        </div>
        <div class="form-group">
          <label class="form-label">Name <span class="text-danger">*</span></label>
          <input type="text" class="form-control" [(ngModel)]="categoryForm.name" placeholder="Enter category name" />
        </div>
        <div class="form-group">
          <label class="form-label">Description</label>
          <textarea
            class="form-control"
            [(ngModel)]="categoryForm.description"
            placeholder="Enter category description"
            rows="3"
          ></textarea>
        </div>
        <div class="form-group">
          <label class="form-label">Status</label>
          <select class="form-select" [(ngModel)]="categoryForm.status">
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="closeModal()">
          <i class="bi bi-x-lg"></i> Cancel
        </button>
        <button type="button" class="btn btn-primary" (click)="save()">
          <i class="bi bi-check-lg"></i> {{ isEditing() ? 'Save Changes' : 'Save' }}
        </button>
      </div>
    </div>
  </div>
}

@if (showToast()) {
  <div class="toast-container show">
    <div class="toast success">
      <div class="toast-icon"><i class="bi bi-check-circle-fill"></i></div>
      <div class="toast-content">
        <div class="toast-title">Success!</div>
        <div class="toast-message">{{ toastMessage() }}</div>
      </div>
    </div>
  </div>
}
